import React, { createContext, useCallback, useLayoutEffect, useRef, useState } from "react";

export const TONIX_TONIGHT_BANNER_SESSION_KEY = "tonix-tonight-banner-dismissed";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const headerRef = useRef(null);
  const stickyIsiRef = useRef(null);
  const isiRef = useRef(null);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");
  const [modalType, setModalType] = useState("");
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const [tonixTonightBannerOpen, setTonixTonightBannerOpen] = useState(null);

  useLayoutEffect(() => {
    try {
      const dismissed = sessionStorage.getItem(TONIX_TONIGHT_BANNER_SESSION_KEY) === "true";
      setTonixTonightBannerOpen(!dismissed);
    } catch {
      setTonixTonightBannerOpen(true);
    }
  }, []);

  const dismissTonixTonightBanner = useCallback(() => {
    try {
      sessionStorage.setItem(TONIX_TONIGHT_BANNER_SESSION_KEY, "true");
    } catch {
      // sessionStorage may be unavailable (private mode, security policy)
    }
    setTonixTonightBannerOpen(false);
  }, []);

  const showTonixTonightBanner = tonixTonightBannerOpen === true;

  const openModal = (url, type) => {
    setExitUrl(url);
    setShowModal(true);
    setModalType(type);
  };

  const closeModal = () => {
    setShowModal(false);

    // bug fix: prevent the modal from closing before the exit URL is opened
    // without this, the exit url clears too fast, and the browser opens a tab with the same url instead of the exit one
    setTimeout(() => {
      setExitUrl("");
    }, 100);

    setModalType("");


    if (modalType === "hcp") {
      localStorage.setItem("tonix-tonmya-hcpModalSeen", "true");
    }
  };

  const store = {
    headerRef,
    stickyIsiRef,
    isiRef,
    isHeaderVisible,
    setIsHeaderVisible,
    showModal,
    setShowModal,
    exitUrl,
    openModal,
    modalType,
    setModalType,
    closeModal,
    activeSectionIndex,
    setActiveSectionIndex,
    showTonixTonightBanner,
    dismissTonixTonightBanner,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;
export { AppProvider };
